import React,{ Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './pages/login/login';
import Home from './pages/home/home';
import Skill from "./pages/skill/skill";
import SkillDetail from "./pages/skillDetail/skillDetail";
import Case from "./pages/case/case";
import CaseDetail from "./pages/caseDetail/caseDetail";
import Care from "./pages/care/care";
import Basic from "./pages/basic/basic";
import Student from "./pages/student/student";
import Score from "./pages/score/score";
import Info from "./pages/info/info";
import Password from "./pages/password/password";
import Grade from "./pages/grade/grade";
import IllCase from "./pages/illCase/illCase";
import Exam from "./pages/exam/exam";
import View from "./pages/exam/view";
import SkillAd from "./pages/skillAd/skillAd";
import Question from "./pages/question/question";
import CaseAd from "./pages/caseAd/caseAd";
import Ask from "./pages/question/ask";
import Check from "./pages/check/check";
import Paper from "./pages/paper/paper";
import IllQuestion from "./pages/illQuestion/illQuestion";
import Mine from "./pages/question/mine";
import Teacher from "./pages/teacher/teacher";
import PreviewCom from "./pages/paper/previewCom";
import PreviewIll from "./pages/paper/previewIll";
import Cover from "./pages/exam/cover";
import Finish from "./pages/exam/finish";
import './App.css';
import {Study} from "./pages/study/study";
import {Analysis} from "./pages/analysis/analysis";
import Forget from "./pages/forget/forget";
import Manage from "./pages/manage/manage";
import Edit from "./pages/check/edit";
import IllEdit from "./pages/illQuestion/illEdit";
import ComEdit from "./pages/paper/ComEdit"

/**
 * 应用的根组件
 */
export default class App extends Component {
  render (){
    return (
        <Router>
          <Switch>
            <Route path='/login' component={Login} />
            <Route path='/skill' component={Skill} />
            <Route path='/skillDetail' component={SkillDetail} />
            <Route path='/case' component={Case} />
            <Route path='/caseDetail' component={CaseDetail} />
            <Route path='/basic' component={Basic} />
            <Route path='/care' component={Care} />
            <Route path='/question' component={Question} />
            <Route path='/info' component={Info} />
            <Route path='/student' component={Student} />
            <Route path='/score' component={Score} />
            <Route path='/password' component={Password} />
            <Route path='/grade' component={Grade} />
            <Route path='/illCase' component={IllCase} />
            <Route path='/cover' component={Cover} />
            <Route path='/exam' component={Exam} />
            <Route path='/view' component={View} />
            <Route path='/skillAd' component={SkillAd} />
            <Route path='/caseAd' component={CaseAd} />
            <Route path='/question' component={Question} />
            <Route path='/ask' component={Ask} />
            <Route path='/mine' component={Mine} />
            <Route path='/check' component={Check} />
            <Route path='/paper' component={Paper} />
            <Route path='/teacher' component={Teacher} />
            <Route path='/illQuestion' component={IllQuestion} />
            <Route path='/previewCom' component={PreviewCom} />
            <Route path='/previewIll' component={PreviewIll} />
            <Route path='/paper' component={Paper} />
            <Route path='/teacher' component={Teacher} />
            <Route path='/illQuestion' component={IllQuestion} />
            <Route path='/finish' component={Finish} />
            <Route path='/study' component={Study} />
            <Route path='/analysis' component={Analysis} />
            <Route path='/forget' component={Forget}/>
            <Route path='/manage' component={Manage}/>
            <Route path='/edit' component={Edit}/>
            <Route path='/illEdit' component={IllEdit}/>
            <Route path='/comEdit' component={ComEdit}/>
            <Route path='/' component={Home} />
          </Switch>
        </Router>
    )
  }
}
